import React from 'react';
import { motion } from 'framer-motion';

const LoadingScreen = () => {
  return (
    <motion.div
      initial={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="fixed inset-0 z-50 flex items-center justify-center bg-dark-blue"
    >
      <div className="text-center">
        <motion.img
          src="/images/logo/Ikon.png"
          alt="HypeNode Nusantara"
          className="w-20 h-20 mx-auto mb-4"
          animate={{
            scale: [1, 1.2, 1],
            rotate: [0, 360, 0],
          }}
          transition={{
            duration: 2,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        />
        <motion.div
          initial={{ width: 0 }}
          animate={{ width: '100%' }}
          transition={{ duration: 1.5 }}
          className="h-1 bg-gradient-to-r from-cyan-dark to-cyan rounded-full max-w-xs mx-auto"
        />
      </div>
    </motion.div>
  );
};

export default LoadingScreen;
